<template>
    <div class="scholarStatus safe-distance-top">
        <div class="scholarStatus_top">
            <van-icon
                style="position: absolute; left: 10px"
                size="25"
                name="arrow-left"
                @click="to()"
            />
            <div class="my">{{ $route.query.title }}</div>
        </div>
        <div class="scholarStatus_bottom">
            <img src="../../../../assets/mylogin/underReview2x.png" alt="" />
            <p class="text">提交成功,等待审核结果</p>
        </div>
        <div class="scholarStatus_button">
            <van-button type="default" round class="vieworder" @click="vieworder">
                返回首页
            </van-button>
        </div>
    </div>
</template>

<script>
export default {
    name: "scholarStatus",
    data() {
        return {};
    },
    created() {
        this.status = this.$route.query.status;
    },
    methods: {
        to() {
            if (this.$route.query.out) {
                // 有out代表是APP进入
                if (this.$global.isAndroid_ios()) {
                    window.android.gubeit();
                } else {
                    window.webkit.messageHandlers.gubeit.postMessage("null"); //ios
                }
                return;
            }
            this.$router.push({ path: "/My" });
        },
        // 返回首页
        vieworder() {
            if (this.$route.query.out) {
                // 有out代表是APP进入
                if (this.$global.isAndroid_ios()) {
                    window.android.gubeit();
                } else {
                    window.webkit.messageHandlers.gubeit.postMessage("null"); //ios
                }
                return;
            }
            this.$router.push("index");
        },
    },
};
</script>

<style lang="scss" scoped>
.scholarStatus {
    width: 100vw;
    min-height: 100vh;
    background: #fff;

    .scholarStatus_top {
        height: 44px;
        display: flex;
        justify-content: center;
        align-items: center;
        background: #fff;
        line-height: 44px;

        .my {
            font-size: 18px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #333333;
            background: #fff;
        }
    }

    .scholarStatus_bottom {
        width: 100%;
        margin-top: 139px;
        text-align: center;

        img {
            width: 83px;
            height: 83px;
        }

        .text {
            font-size: 15px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #333333;
        }
    }

    .scholarStatus_button {
        width: 75%;
        height: 40px;
        margin: 56px auto;

        .vieworder {
            display: flex;
            justify-content: center;
            align-items: center;
            margin: 0 auto;
            width: 130px;
            height: 40px;
        }
    }
}
</style>
